// Карточка со списком строк матча (турнир, команда, игрок…). Заголовок может вести на вкладку.
import { useNavigate } from 'react-router-dom';
import type { MatchRow } from '../api/types';
import { paths } from '../nav';
import { Card } from './Card';
import { MatchRowView } from './MatchRowView';

export function MatchListCard({ title, matches, onOpenAll, showLeague = false }: {
  title?: string; matches: MatchRow[]; onOpenAll?: () => void; showLeague?: boolean;
}) {
  const navigate = useNavigate();
  if (!matches.length) return null;
  return (
    <Card title={title} onOpen={onOpenAll} flush>
      {matches.map((m) => <MatchRowView key={m.id} match={m} showLeague={showLeague} context={title} onOpen={(id) => navigate(paths.match(id))} />)}
    </Card>
  );
}
